export var SnapshotScheduleType;
(function (SnapshotScheduleType) {
    SnapshotScheduleType["MINUTE"] = "m";
    SnapshotScheduleType["HOUR"] = "h";
    SnapshotScheduleType["DAY"] = "d";
    SnapshotScheduleType["WEEK"] = "w";
    SnapshotScheduleType["MONTH"] = "mo";
    SnapshotScheduleType["YEAR"] = "y";
})(SnapshotScheduleType || (SnapshotScheduleType = {}));
